import React, { useState, useRef, useEffect } from 'react';

export default function FontSelect({
  value,
  options,
  onChange,
  disabled = false,
  placeholder = 'Select font',
  buttonStyle = null,
  listStyle = null,
  optionStyle = null,
  containerStyle = null,
  getButtonLabel = null,
}) {
  const [open, setOpen] = useState(false);
  const listRef = useRef(null);
  const selectedOption = options.find((option) => option.value === value) || null;
  const buttonLabel = typeof getButtonLabel === 'function'
    ? getButtonLabel(selectedOption)
    : selectedOption?.buttonLabel || selectedOption?.label || value || placeholder;
  const buttonFontFamily = selectedOption?.fontFamily || selectedOption?.value || value || 'Inter';

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (listRef.current && !listRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    if (disabled) {
      setOpen(false);
    }
  }, [disabled]);

  return (
    <div className="font-select" ref={listRef} style={containerStyle || undefined}>
      <button
        type="button"
        className="font-select-button"
        onClick={() => {
          if (disabled) return;
          setOpen((prev) => !prev);
        }}
        disabled={disabled}
        style={{
          fontFamily: buttonFontFamily,
          cursor: disabled ? 'not-allowed' : 'pointer',
          opacity: disabled ? 0.65 : 1,
          ...(buttonStyle || {}),
        }}
      >
        <span style={{ flex: '1 1 auto', minWidth: 0 }}>{buttonLabel}</span>
        <span className="caret" aria-hidden="true" style={{ fontSize: 10, opacity: 0.72 }}>
          ▾
        </span>
      </button>
      {open && (
        <ul
          className="font-select-list"
          style={listStyle || undefined}
        >
          {options.map((option) => (
            <li
              key={option.value}
              className="font-select-option"
              style={{
                fontFamily: option.fontFamily || option.value || 'Inter',
                ...(optionStyle || {}),
              }}
              onClick={() => {
                if (disabled) return;
                onChange(option.value);
                setOpen(false);
              }}
            >
              {option.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
